import React from 'react';
import completedImg from 'assets/img/completed.svg'
import './completed-item.scss'

const CompletedItem = ({name, date, type}) => {
    return (
        <div className="completed-item">
            <h4>{type}</h4>
            <div>
                <p>{name} ({date})</p>
                <img src={completedImg} alt=""/>
            </div>
        </div>
    );
};

export default CompletedItem;